import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Help = ({
  height = 24,
  width = 24,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M9.56006 9.70261C9.56014 9.30975 9.6736 8.92448 9.88805 8.58889C10.1025 8.2533 10.4097 7.98032 10.776 7.79977C11.1424 7.61923 11.5538 7.53807 11.9653 7.56516C12.3767 7.59226 12.7725 7.72657 13.1093 7.95342C13.446 8.18026 13.7108 8.49091 13.8748 8.85142C14.0387 9.21192 14.0954 9.6084 14.0387 9.99753C13.982 10.3867 13.8141 10.7535 13.5533 11.0578C13.2926 11.3622 12.9489 11.5925 12.5601 11.7234C12.3406 11.7973 12.1507 11.9342 12.0163 12.1152C11.882 12.2963 11.8099 12.5125 11.8101 12.7342V13.4528"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.8101 15.6553C11.6123 15.6553 11.4189 15.7111 11.2545 15.8158C11.09 15.9204 10.9619 16.0692 10.8862 16.2432C10.8105 16.4173 10.7907 16.6088 10.8293 16.7935C10.8679 16.9783 10.9631 17.148 11.103 17.2812C11.2428 17.4144 11.421 17.5051 11.615 17.5418C11.8089 17.5786 12.01 17.5597 12.1927 17.4876C12.3755 17.4155 12.5316 17.2935 12.6415 17.1368C12.7514 16.9802 12.8101 16.7961 12.8101 16.6077C12.8101 16.3551 12.7047 16.1128 12.5172 15.9342C12.3296 15.7556 12.0753 15.6553 11.8101 15.6553Z"
      stroke={getColor(color, isColorInherited)}
    />
    <path
      d="M3.56006 11.9976C3.56006 14.2353 4.44901 16.3814 6.03135 17.9638C7.61368 19.5461 9.75979 20.4351 11.9976 20.4351C14.2353 20.4351 16.3814 19.5461 17.9638 17.9638C19.5461 16.3814 20.4351 14.2353 20.4351 11.9976C20.4351 9.75979 19.5461 7.61368 17.9638 6.03135C16.3814 4.44901 14.2353 3.56006 11.9976 3.56006C9.75979 3.56006 7.61368 4.44901 6.03135 6.03135C4.44901 7.61368 3.56006 9.75979 3.56006 11.9976V11.9976Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </SvgIcon>
);
